import OrganizationContainer from '@shared/hooks/state/OrganizationContainer';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import AlertsContainer from './state/AlertsContainer';

export function useLicenseKeyFetching() {
    const { t } = useTranslation();
    const { organizationId } = useParams<{ organizationId: string }>();
    const { showError } = AlertsContainer.useContainer();
    const {
        orgManagedKeysLicenseRef,
        orgManagedLicenseKeys,
        loadingDataRef,
        loadingData,
        handleLoadingDataChange,
        getOrgManagedLicenseKeys,
    } = OrganizationContainer.useContainer();

    useEffect(() => {
        async function initializeLicenseKeys() {
            if (!organizationId || loadingDataRef.current.licenseKeys == true) return;
            handleLoadingDataChange('licenseKeys', true);
            const key = orgManagedKeysLicenseRef.current.find((k) => k.originatedByOrganizationId === organizationId);

            if (key) {
                handleLoadingDataChange('licenseKeys', false);
                return;
            }

            try {
                await getOrgManagedLicenseKeys(organizationId);
            } catch (error) {
                showError(t('common:license.key.error'));
            } finally {
                handleLoadingDataChange('licenseKeys', false);
            }
        }
        initializeLicenseKeys();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId]);

    return { orgManagedLicenseKeys, isLoading: loadingData.licenseKeys };
}
